var luxinLanguages = {
};
export default luxinLanguages
